import React from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles(() => ({
  media: {
    height: 0,
    paddingTop: "56.25%",
    position: "relative",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  }
}));

export default function TradePresenterCardImage(props) {
  const classes = useStyles();
  const theme = useTheme();
  let pageLink = "";
  if (props.link != null) {
    pageLink = props.link;
  }
  return (
    <NavLink to={pageLink} exact>
      <Box
        className={classes.media}
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 42, 84, 0.4),rgba(0, 42, 84, 0.75)), url(" +
            props.image +
            ")"
        }}
      >
        <Box
          position='absolute'
          bottom={theme.spacing(2)}
          left={theme.spacing(2)}
          px={2}
          color={theme.palette.common.white}
        >
          <Typography variant='overline' gutterBottom className='line-clamp-1'>
            <small>{props.subtitle}</small>
          </Typography>
          <Typography variant='h6' gutterBottom className='line-clamp-3'>
            {props.title}
          </Typography>
        </Box>
      </Box>
    </NavLink>
  );
}
